import React, {useState, useRef, useEffect} from 'react'
import './msquiz.css'
import {msOfficeQuestions} from './quizdata.js'
import { headerImg } from '../home/data.js'
import { useNavigate } from 'react-router-dom'
import LazyImage from '../LazyImage.jsx'

const Msquiz = (props) => {

  // console.log('props',props.stuName)
  // console.log('props',props.getEmailId)
  // console.log('props',props.getQuizId)

  const [loading, setLoading] = useState(false);

  const Navigate = useNavigate();

  const [submitDisable, setSubmitDisable] = useState(true);
  const [nextDisable, setNextDisable] = useState(false);
  const [prevDisable, setPrevDisable] = useState(true);
  const [userAnswers, setUserAnswers] = useState({});

  // const data = msOfficeQuestions
  // let [index, setIndex] = useState(0);
  // let [question, setQuestion] = useState(data[index])
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);
  const [question, setQuestion] = useState(null);
  
  let [lock, setLock] = useState(false);
  let [score, setScore] = useState(0);
  let [result, setResult] = useState(false);
  let [timeLeft, setTimeLeft] = useState(600); // 10*60 sec
  const fullscreenCountdownRef = useRef(null);


  const [modalMessage, setModalMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  
  // let Option1 = useRef(null);
  // let Option2 = useRef(null);
  // let Option3 = useRef(null);
  // let Option4 = useRef(null);

  // let options_Array = [Option1,Option2,Option3,Option4];
 
  const shuffledArray = (array) => {
    return [...array].sort(() => Math.random() - 0.5)
  }
  
  useEffect(() => {

    // const goFullscreen = () => {...};

    // goFullscreen();

    const handleFullscreenChange = () => {
      if(!document.fullscreenElement) {
        
        let timeLeft = 15;
        fullscreenCountdownRef.current = setInterval(() => {
          timeLeft -= 1;
          setModalMessage(`You exited fullscreen. Exam Auto-submitting in ${timeLeft}s`);
          
          if (timeLeft <= 0) {
            clearInterval(fullscreenCountdownRef.current);
            setResult(true);
            setShowModal(false);
          }
          
        }, 1000);
        setModalMessage(`You exited fullscreen. Auto-submitting in ${timeLeft}s`);
        setShowModal(true);
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, [])

  const handleContinueTest = async () => {
  setShowModal(false);
  clearInterval(fullscreenCountdownRef.current);

  // Optional: try to re-enter fullscreen
  if (document.documentElement.requestFullscreen) {
    try {
      await document.documentElement.requestFullscreen();
    } catch (err) {
      console.warn('Fullscreen request failed', err);
    }
  }
};


  useEffect(() => {
    const shuffled = shuffledArray(msOfficeQuestions);
    setData(shuffled);
    setQuestion(shuffled[0]);
  }, [])

  
  useEffect(() => {
    if (data.length === !question) return;

    setPrevDisable(index === 0);
    setNextDisable(index === data.length - 1);
    setSubmitDisable(index !== data.length - 1 || !userAnswers[index]);
  }, [index, data.length, userAnswers, question]);

  // const clearOptionClasses = () => {
  //   options_Array.forEach((option) => {
  //     if(option.current){
  //     option.current.classList.remove("correct", "wrong");
  //     }
  //   });
  // }

  // const applyAnswerClass = (selected, correct) => {
  //   if(!options_Array[selected - 1] || !options_Array[correct - 1]) return;

  //   if(selected === correct){
  //     options_Array[selected - 1].current.classList.add("correct");
  //   }
  //   else{
  //     options_Array[selected - 1].current.classList.add("wrong");
  //     options_Array[correct - 1].current.classList.add("correct");
  //   }
  // }

  // const checkAns = (e,ans) => {
  //   if(lock || userAnswers[index]) return;

  //   const correct = question.answer;
  //   if(ans === correct){
  //     e.target.classList.add("correct");
  //     setScore((prev)=>prev+1);
  //   }
  //   else{
  //     e.target.classList.add("wrong");
  //     options_Array[correct - 1].current.classList.add("correct");
  //   }

  //   setUserAnswers((prev) => ({...prev, [index]: ans}));
  //   setLock(true);

  //   if (index === data.length -1){
  //     setSubmitDisable(false);
  //   }
  
  // }
  const checkAns = (ans) => {
    if(lock || userAnswers[index]) return;

    const correct = question.answer;
    if(ans === correct){
      setScore((prev)=>prev+1);
    }

    // applyAnswerClass(ans, correct);

    setUserAnswers((prev) => ({...prev, [index]: ans}));
    setLock(true);

    if (index === data.length -1){
      setSubmitDisable(false);
    }
  
  }

  // const previous = () =>{
  //   const preIndex = index - 1;
  //   const preQues = data[preIndex];
  //   if(preIndex >= 0){
  //     clearOptionClasses();
  //     setIndex(preIndex);
  //     setQuestion(preQues);
  //     // setLock(false);
      
  //     // Restore prev ans if available
  //     const userAns = userAnswers[preIndex];
  //     if(userAns){
  //       applyAnswerClass(userAns, preQues.answer);
  //       setLock(true);
  //     }
  //     else{
  //       setLock(false);
  //     }
  // }
  // }

  // const next = () => {
  //   const newIndex = index + 1;
  //   if(newIndex < data.length){
  //     clearOptionClasses();
  //     setIndex(newIndex);
  //     setQuestion(data[newIndex]);
      
  //     const userAns = userAnswers[newIndex];
  //     if(userAns){
  //       applyAnswerClass(userAns, data[newIndex].answer);
  //       setLock(true);
  //     }
  //     else{
  //       setLock(false);
  //     }
  //   }
  // }
    
  const getOptionClass = (optNum) => {
  const selected = userAnswers[index];
  const correct = question?.answer;

  if(!selected) return "";

  if (selected === optNum && selected === correct) return "correct";
  if (selected === optNum && selected !== correct) return "wrong";
  if (optNum === correct && selected) return "correct"; // highlight correct after wrong selection
  return "";
};

  const previous = () => {
  const preIndex = index - 1;
  if (preIndex >= 0) {
    setIndex(preIndex);
    setQuestion(data[preIndex]);
    setLock(!!userAnswers[preIndex]); // true if already answered
  }
};

const next = () => {
  const newIndex = index + 1;
  if (newIndex < data.length) {
    setIndex(newIndex);
    setQuestion(data[newIndex]);
    setLock(!!userAnswers[newIndex]); // lock if already answered
  }
};


  const submitNxt = async() => {
      if(index === data.length - 1 && lock){
        setResult(true);
      }

      setLoading(true);

      const updatedFormData = {
        student: props.stuName,
        email: props.getEmailId,
        quiz: props.getQuizId,
        result: score,
      };
        try{
        // const res = await fetch("http://localhost:5000/send/quiz/results",{
        const res = await fetch("https://api-express-node-bd0o.onrender.com/send/quiz/results",{
          method:"POST",
          headers:{"Content-Type": "application/json"},
          body: JSON.stringify(updatedFormData),
        });
        const result = await res.json();
        setModalMessage(result.success? `Submission Successful! You scored ${score} out of ${data.length}.` : "Oops! Something went wrong. Please try again later.");
        setShowModal(true);
      }
      catch(error){
        console.log("Error sending email:", error);
        setModalMessage("Something went wrong. Please try again later.");
        setShowModal(true);
      }
      finally{
        setLoading(false)
      }
  }

  // const submitNxt = () => {
  //   if(lock === true){
  //     if(index === data.length -1){
  //       setResult(true);
  //       return 0;
  //     }
  //     // setIndex(++index);
  //     // setQuestion(data[index]);
  //     const newIndex = index + 1;
  //     setIndex(newIndex);
  //     setQuestion(data[newIndex]);
  //     setLock(false);
  //     options_Array.map((option)=>{
  //       option.current.classList.remove("correct");
  //       option.current.classList.remove("wrong");
  //       return null;
  //     })
  //   }
  // }

  const exitFullscreen = () => {
    if (!document.fullscreenElement) return;
    try{
      if(document.exitFullscreen && document.hasFocus()) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } catch (err){
      console.warn("Failed to exit fullscreen:", err);
    }
  }
  
  const reset = () => {
    exitFullscreen();
    Navigate('/', { replace: true });
  }
  
  // const reset = () => {
  //   const shuffled = shuffledArray(msOfficeQuestions);
  //   setData(shuffled);
  //   setIndex(0);
  //   // setQuestion(data[0]);
  //   setQuestion(shuffled[0]);
  //   setResult(false);
  //   setScore(0);
  //   setLock(false);
  //   setTimeLeft(300);
  //   setUserAnswers({});
  //   setSubmitDisable(true);
  //   setNextDisable(false);
  //   setPrevDisable(true)
  //   // clearOptionClasses();
  //   exitFullscreen();
  // }

  useEffect(() => {
    if(result) return;

    if(timeLeft === 0){
      setResult(true);
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft(timeLeft -1);
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, reset]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  }

  const totalQuestions = data.length;
  const answeredQuestions = Object.keys(userAnswers).length;
  const progressPercentage = totalQuestions === 0 ? 0 : Math.round((answeredQuestions / totalQuestions) * 100);

  return (
    <div>
        <div className="container-2">
          {/* <img src={headerImg.header_img_url} alt="logo" style={{width: '100%', height: '215px'}}/> */}
          <LazyImage src={headerImg.header_img_url} alt="logo" className="#" style={{width: '100%', height: '215px'}} />
        </div>
        <div className="container-fluid bg-color">
        <div className="bg-container">
            <h1 className='quiz'>Quiz</h1>
            <hr className='hr-tag'/>
            {result?<>
            <div>
              <h2>You Scored {score} out of {data.length}</h2>
              <button className='next-btn' onClick={reset}>Exit</button>
            </div>
            </>: question && (<>
            <div className="mb-1">
              <label className="form-label">
                Answered: {answeredQuestions} of {totalQuestions}
              </label>
              <div className="progress w-100" style={{height: '20px'}}>
                <div className="progress-bar bg-success progress-bar-striped progress-bar-animated"
                role='progressbar'
                style={{width: `${progressPercentage}%`}}
                aria-valuenow={progressPercentage}
                aria-valuemin="0"
                aria-valuemax="100"
                >
                  {progressPercentage}%
                </div>
              </div>
            </div>

            <div className="timer">Time Left: {formatTime(timeLeft)}</div>
            <div className="#">
                <h4 className='Q'>{index + 1}. {question.question}</h4>
                <ul className='option-list'>
                    {/* <li ref={Option1} onClick={(e)=>{checkAns(e,1)}}>{question.option1}</li> */}
                    {/* <li className={getOptionClass(1)} onClick={() => checkAns(1)}>{question.option1}</li> */}
                    <li className={`${getOptionClass(1)} ${lock ? 'locked':''}`} onClick={() => checkAns(1)}>{question.option1}</li>
                    <li className={`${getOptionClass(2)} ${lock ? 'locked':''}`} onClick={() => checkAns(2)}>{question.option2}</li>
                    <li className={`${getOptionClass(3)} ${lock ? 'locked':''}`} onClick={() => checkAns(3)}>{question.option3}</li>
                    <li className={`${getOptionClass(4)} ${lock ? 'locked':''}`} onClick={() => checkAns(4)}>{question.option4}</li>
                </ul>
                {!prevDisable && (<button className='prev-btn' onClick={previous} disabled={prevDisable}>Previous</button>)}
                {!nextDisable && (<button className='next-btn' onClick={next} disabled={nextDisable}>Next</button>)}
                {!submitDisable && (<button className='submit-btn' onClick={submitNxt} disabled={submitDisable}>Submit & Finish</button>)}
                <div className="index">{index + 1} of {data.length} questions</div>
            </div>
            </>)}
        </div>
        </div>

                        {loading && (
                          <div className="loading-overlay">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        )}
                        
                        {showModal && (
                          <div className="modal-overlay">
                            <div className="modal-content">
                              <div><button className='close-btn' onClick={() => setShowModal(false)}></button></div>
                              <p className='modal-msg'>{modalMessage}</p>
                              <button className="btn btn-primary" onClick={handleContinueTest}>Continue Test..</button>
                            </div>
                          </div>
                        )}
                
    </div>
  )
}

export default Msquiz